<template>
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_312_7502)">
      <mask
        id="mask0_312_7502"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="36"
      >
        <path d="M0 -7.62939e-06H36V36H0V-7.62939e-06Z" fill="white" />
      </mask>
      <g mask="url(#mask0_312_7502)">
        <path
          d="M17.2098 19.1109L11.6319 24.6888C11.5658 24.755 11.6127 24.8683 11.7063 24.8683H15.3306C15.4243 24.8683 15.4712 24.9815 15.4049 25.0477L9.03088 31.4219C8.9439 31.5088 9.05134 31.6486 9.15772 31.5872L22.047 24.1456C22.1281 24.0987 22.1122 23.9772 22.0217 23.953L19.3102 23.2264C19.2321 23.2055 19.2059 23.1078 19.2818 23.0689L23 19"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M28.0458 20.9999L27 22.0458"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.04583 20.9999L8 22.0457"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.08769 28.6797L2.17969 30.5878"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.759 25L25 26.759"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.84981 31.0679L3.95898 33.9587"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.7906 31.1565L12.2227 33.7245"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.72394 26.0001L8 26.724"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.3724 28.3124L17.8672 31.8176"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.7841 27.6539L28.373 30.0649"
          class="stroke-current"
          stroke-opacity="0.92"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <path
        d="M27.5003 9.1599C25.9641 5.70357 22.4756 2.99998 18.5 2.99998C14.5167 2.99998 11.0323 5.71163 9.4997 9.1599C7.03452 9.22578 5 11.2434 5 13.7245C5 16.2472 7.10107 18.2922 9.62378 18.2922H27.3762C29.8989 18.2922 32 16.2472 32 13.7245C32 11.2434 29.9655 9.22578 27.5003 9.1599Z"
        class="stroke-current"
        stroke-width="2.39004"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.5 24C6.5 24.8284 5.82841 25.5 5 25.5C4.17159 25.5 3.5 24.8284 3.5 24C3.5 23.1716 4.17159 22.5 5 22.5C5.82841 22.5 6.5 23.1716 6.5 24Z"
        class="stroke-current"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.25 31.25C25.25 32.0784 24.5784 32.75 23.75 32.75C22.9216 32.75 22.25 32.0784 22.25 31.25C22.25 30.4216 22.9216 29.75 23.75 29.75C24.5784 29.75 25.25 30.4216 25.25 31.25Z"
        class="stroke-current"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M33.25 23.25C33.25 24.0784 32.5784 24.75 31.75 24.75C30.9216 24.75 30.25 24.0784 30.25 23.25C30.25 22.4216 30.9216 21.75 31.75 21.75C32.5784 21.75 33.25 22.4216 33.25 23.25Z"
        class="stroke-current"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_312_7502">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
